<template>
  <div class="choosen-order__card-wrapper">
    <div class="choose-order__card-company">
      <div class="choose-order__card-company__logo">
        <img
          :src="`https://www.biletdv.ru/Content/images/companies/${info.OperatingAirline.CodeLat}.svg`"
          :alt="info.OperatingAirline.NameLat"
          class="choose-order__card-company__logo-img"
        />
      </div>
      <div class="choose-order__card-company__info">
        <div class="choose-order__card-company__info-name">
          {{ info.OperatingAirline.NameRus }}
        </div>
        <div class="choose-order__card-company__info-duration">
          {{
            getHoursTimeInFlight(info.TimeDifference) +
            "ч " +
            getMinutesTimeInFlight(info.TimeDifference) +
            "м " +
            getRouteMeth(info.AirCraft)
          }}
        </div>
      </div>
      <div class="choose-order__card-company__sidebar">
        <router-link
          :to="{
            name: 'RouteCardInfo',
            params: {
              flightId: info.DBFlightID,
            },
          }"
          data-num="passengers"
          class="passengers-card"
        >
          <Button label="Подробнее" class="p-button-outlined p-button-sm" />
        </router-link>
      </div>
    </div>
    <div class="choosen-order__card-route">
      <div class="choosen-order__card-route__scheme">
        <div class="choosen-order__card-route__scheme-marker"></div>
        <div class="choosen-order__card-route__scheme-connector"></div>
        <div class="choosen-order__card-route__scheme-marker"></div>
      </div>
      <div class="choosen-order__card-route__dates">
        <div class="choosen-order__card-route__dates-departure">
          <div class="choosen-order__card-route__dates-departure__time">
            {{ getTime(info.DepartureDate) }}
          </div>
          <div class="choosen-order__card-route__dates-departure__date">
            {{
              getDate(info.DepartureDate) +
              ", " +
              getWeekDay(info.DepartureDate)
            }}
          </div>
        </div>
        <div class="choosen-order__card-route__dates-arrival">
          <div class="choosen-order__card-route__dates-arrival__time">
            {{ getTime(info.ArrivalDate) }}
          </div>
          <div class="choosen-order__card-route__dates-arrival__date">
            {{
              getDate(info.ArrivalDate) + ", " + getWeekDay(info.ArrivalDate)
            }}
          </div>
        </div>
      </div>
      <div class="choosen-order__card-route__citys">
        <div class="choosen-order__card-route__citys-departure">
          <div class="choosen-order__card-route__citys-departure__city">
            {{ info.Departure.City.NameRus }}
          </div>
          <div class="choosen-order__card-route__citys-departure__airport">
            {{
              info.Departure.DepAirportNameRus +
              ", " +
              info.Departure.DepAirportCodeLat
            }}
          </div>
        </div>
        <div class="choosen-order__card-route__citys-arrival">
          <div class="choosen-order__card-route__citys-arrival__city">
            {{ info.Arrival.City.NameRus }}
          </div>
          <div class="choosen-order__card-route__citys-arrival__airport">
            {{
              info.Arrival.ArrAirportNameRus +
              ", " +
              info.Arrival.ArrAirportCodeLat
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "@vue/runtime-core";
import Button from "primevue/button";

export default defineComponent({
  name: "RouteCard",
  components: {
    Button,
  },
  props: ["info"],
  data() {
    return {
      visibleFull: false,
      hoursWords: ["час", "часа", "часов"],
      minutesWords: ["минута", "минуты", "минут"],
      activeOrder: this.$route.params,
      month: [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ],
    };
  },
  methods: {
    getTimeOfRoute(depDate: any, arrDate: any) {
      let depTime = new Date(depDate);
      let arrTime = new Date(arrDate);
      let diffCount: any = depTime.valueOf() - arrTime.valueOf();
      let finalHours = Math.floor((diffCount % 86400000) / 3600000);
      let finalMinutes = Math.floor(((diffCount % 86400000) % 3600000) / 60000);
      return finalHours + "ч " + finalMinutes + "м в пути";
    },
    getHoursTimeInFlight(time: any) {
      let flightHours = 0;
      let splited = time.split(":");
      flightHours += +splited[0];
      return flightHours;
    },
    getMinutesTimeInFlight(time: any) {
      let flightMinutes = 0;
      let splited = time.split(":");
      flightMinutes += +splited[1];
      return flightMinutes;
    },
    getHoursTransferTime(depTrans: any, arrTrans: any) {
      let depTime = new Date(depTrans);
      let arrTime = new Date(arrTrans);
      let diffCount: any = depTime.valueOf() - arrTime.valueOf();
      let finalHours = Math.floor((diffCount % 86400000) / 3600000);
      let finalMinutes = Math.round(((diffCount % 86400000) % 3600000) / 60000);
      return finalHours + "ч " + finalMinutes + "м";
    },
    declOfHours(number: any, words: any) {
      return words[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? Math.abs(number) % 10 : 5]
      ];
    },
    // hide() {
    //   this.$emit("update:visible", false);
    // },
    getWeekDay(date: any) {
      let days = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"];
      let weekDay = new Date(date);
      return days[weekDay.getDay()];
    },
    getDate(date: any) {
      let month = [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ];
      let monthNum = new Date(date);
      return monthNum.getDate() + " " + month[monthNum.getMonth()];
    },
    getAnyDate(date: any) {
      let created: any = new Date(date);
      let createdDay = created.getDate();
      let createdMonth: any = created.getMonth();
      let createdYear = created.getFullYear();
      let createdHours = function () {
        if (created.getHours() < 10) {
          return "0" + created.getHours();
        } else {
          return created.getHours();
        }
      };
      let createdMinutes = function () {
        if (created.getMinutes() < 10) {
          return "0" + created.getMinutes();
        } else {
          return created.getMinutes();
        }
      };
      return (
        createdDay +
        " " +
        this.month[createdMonth] +
        " " +
        createdYear +
        " " +
        createdHours() +
        ":" +
        createdMinutes()
      );
    },
    getTime(date: any) {
      let time = new Date(date);
      let hours = time.getHours();
      let minutes = time.getMinutes();
      if (minutes < 10) {
        return hours + ":0" + minutes;
      }
      return hours + ":" + minutes;
    },
    getHours(date: any) {
      let time = date.split(":");
      let hours = time[0];
      return hours;
    },
    getMinutes(date: any) {
      let time = date.split(":");
      let minutes = time[1];
      return minutes;
    },
    getCompanyLogo(company: any) {
      return `"@/assets/images/companies/${company}.svg"`;
    },
    getTransportInfo(item: any) {
      if (item.Id === 7) {
        return "в пути на автобусе";
      } else if (item.Id === 436) {
        return "в пути на поезде";
      } else {
        return "в полёте на " + item.NameRus;
      }
    },
    getRouteMeth(item: any) {
      if (item.Id === 7) {
        return "в пути на автобусе";
      } else if (item.Id === 436) {
        return "в пути на поезде";
      } else {
        return "в полёте";
      }
    },
  },
  created() {
    const unregisterRouterGuardTwo = this.$router.beforeEach(
      (to: any, from: any, next: any) => {
        if (this.visibleFull == true) {
          next(false);
          this.visibleFull = false;
        } else {
          next();
        }
      }
    );
  },
});
</script>

<style>
@media screen and (max-width: 767px) {
  .choosen-order__card-wrapper {
    align-items: center;
  }

  .choose-order__card-company {
    display: flex;
    align-items: center;
  }

  .choose-order__card-company__info {
    margin-left: 10px;
  }

  .choose-order__card-company__info-name {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
  }

  .choose-order__card-company__info-duration {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    color: #666666;
  }

  .choosen-order__card-route {
    display: flex;
    margin-bottom: 20px;
    margin-top: 10px;
  }

  .choosen-order__card-route__scheme {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 15px;
  }

  .choosen-order__card-route__scheme-marker {
    width: 1rem;
    height: 1rem;
    border: 5px solid #9e9e9e;
    border-radius: 50%;
    color: #9e9e9e;
  }

  .choosen-order__card-route__scheme-connector {
    width: 2px;
    min-height: 50px;
    max-height: 50px;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    background-color: #9e9e9e;
  }

  .choosen-order__card-route__dates {
    margin-top: 13px;
    margin-left: 25px;
  }

  .choosen-order__card-route__dates-departure__time {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__card-route__dates-departure__date {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__card-route__dates-arrival {
    margin-top: 30px;
  }

  .choosen-order__card-route__dates-arrival__time {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__card-route__dates-arrival__date {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__card-route__citys {
    margin-top: 13px;
    margin-left: 25px;
  }

  .choosen-order__card-route__citys-departure__city {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__card-route__citys-departure__airport {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__card-route__citys-arrival {
    margin-top: 30px;
  }

  .choosen-order__card-route__citys-arrival__city {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__card-route__citys-arrival__airport {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__card-info__wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .choose-order__card-company__logo-img {
    max-height: 30px;
    max-width: 30px;
    border-radius: 50%;
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .choosen-order__card-wrapper {
    align-items: center;
  }

  .choose-order__card-company {
    display: flex;
    align-items: center;
  }

  .choose-order__card-company__info {
    margin-left: 10px;
  }

  .choose-order__card-company__info-name {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
  }

  .choose-order__card-company__info-duration {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    color: #666666;
  }

  .choosen-order__card-route {
    display: flex;
    margin-bottom: 20px;
    margin-top: 10px;
  }

  .choosen-order__card-route__scheme {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 15px;
  }

  .choosen-order__card-route__scheme-marker {
    width: 1rem;
    height: 1rem;
    border: 5px solid #9e9e9e;
    border-radius: 50%;
    color: #9e9e9e;
  }

  .choosen-order__card-route__scheme-connector {
    width: 2px;
    min-height: 50px;
    max-height: 50px;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    background-color: #9e9e9e;
  }

  .choosen-order__card-route__dates {
    margin-top: 13px;
    margin-left: 25px;
  }

  .choosen-order__card-route__dates-departure__time {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__card-route__dates-departure__date {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__card-route__dates-arrival {
    margin-top: 30px;
  }

  .choosen-order__card-route__dates-arrival__time {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__card-route__dates-arrival__date {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__card-route__citys {
    margin-top: 13px;
    margin-left: 25px;
  }

  .choosen-order__card-route__citys-departure__city {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__card-route__citys-departure__airport {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__card-route__citys-arrival {
    margin-top: 30px;
  }

  .choosen-order__card-route__citys-arrival__city {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__card-route__citys-arrival__airport {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__card-info__wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .choose-order__card-company__logo-img {
    max-height: 30px;
    max-width: 30px;
    border-radius: 50%;
  }
}

@media screen and (min-width: 1025px) {
  .choosen-order__card-wrapper {
    align-items: center;
  }

  .choose-order__card-company {
    display: flex;
    align-items: center;
  }

  .choose-order__card-company__info {
    margin-left: 10px;
  }

  .choose-order__card-company__info-name {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
  }

  .choose-order__card-company__info-duration {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    color: #666666;
  }

  .choosen-order__card-route {
    display: flex;
    margin-bottom: 20px;
    margin-top: 10px;
  }

  .choosen-order__card-route__scheme {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 15px;
  }

  .choosen-order__card-route__scheme-marker {
    width: 1rem;
    height: 1rem;
    border: 5px solid #9e9e9e;
    border-radius: 50%;
    color: #9e9e9e;
  }

  .choosen-order__card-route__scheme-connector {
    width: 2px;
    min-height: 50px;
    max-height: 50px;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    background-color: #9e9e9e;
  }

  .choosen-order__card-route__dates {
    margin-top: 13px;
    margin-left: 25px;
  }

  .choosen-order__card-route__dates-departure__time {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__card-route__dates-departure__date {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__card-route__dates-arrival {
    margin-top: 30px;
  }

  .choosen-order__card-route__dates-arrival__time {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__card-route__dates-arrival__date {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__card-route__citys {
    margin-top: 13px;
    margin-left: 25px;
  }

  .choosen-order__card-route__citys-departure__city {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__card-route__citys-departure__airport {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__card-route__citys-arrival {
    margin-top: 30px;
  }

  .choosen-order__card-route__citys-arrival__city {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__card-route__citys-arrival__airport {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__card-info__wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .choose-order__card-company__logo-img {
    max-height: 30px;
    max-width: 30px;
    border-radius: 50%;
  }
}
</style>
